import React from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';

import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';

import MuiGrid from '@material-ui/core/Grid';

import ViewWrapper from 'views/ViewWrapper';
import TableDsps from 'components/TableDsps';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
});

const ItemList = styled.ul`
  padding: 0;
`;

const DSPs = ({ ...props }) => {
  const { classes } = props;

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Digital Service Providers
          </MuiTypography>
          <TableDsps />
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(DSPs);
